import request from 'utils/request'

/**
 * 获取账期调整申请待审批列表
 * @param {*} data
 */
export const getApproveList = data =>
  request().post('bp/approveTerm/page', data)

/**
 * 审批
 * @param {*} data
 */
export const doApprove = data => request(false).post('bp/approve', data)

/**
 * 账期调整审批
 * @param {*} data
 */
export const doApproveTerm = data =>
  request(false).post('bp/approve/term', data)

/**
 * 获取批量申请待审批列表
 * @param {*} data
 */
export const getBatchAuditList = data =>
  request().post('bp/batch/task/page', data)

/**
 * 获取批量申请审批详情
 * @param {*} id
 */
export const getBatchApprovalDetail = id =>
  request().get(`bp/batch/task/detail/${id}`)

/**
 * 提交批量申请审批
 * @param {*} data
 */
export const doBatchApprove = data => request().post('bp/batch/approve', data)

export const downloadApplyTable = data =>
  request().post('bp/task/export', data, { responseType: 'arraybuffer' })

  export const downloadTermTable = data =>
  request().post('bp/term/export', data, { responseType: 'arraybuffer' })
  
  // 获取标准账期
  export const getPeriodists = data => request().post('accountPeriod/periodLists', data)